export default {
  internalWarranty: [],
  externalWarranty: [],
  allWarranty: [],
  warranty: [],
  optionWarranty: {},
};
